module.exports = __webpack_public_path__ + "img/rede-2025-02.41c634ae.jpg";